import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import CaseStudyTemplate from '../../components/shared/CaseStudyTemplate';

const CPTPage = () => (
  <PageLayout>
    <CaseStudyTemplate
      seoTitle="CPT Case Study | Kalobrate"
      seoDescription="See how Kalobrate helped bus and coach operators understand workplace mental health through practical, evidence-led talks at regional CPT events."
      canonical="/results/cpt"
      client="Confederation of Passenger Transport"
      headline="Helping transport leaders make sense of mental health at work"
      sector="Bus and coach transport"
      typeOfWork="Speaking and sector engagement"
      intro={[
        'Bus and coach operators face a combination of operational pressure, public-facing work, fatigue, isolation and responsibility for passenger safety.',
        'The Confederation of Passenger Transport wanted its members to receive practical guidance on workplace mental health that reflected the realities of the sector.',
      ]}
      sections={[
        {
          heading: 'The situation',
          content: [
            'Mental health can feel difficult for employers to address, particularly when leaders are concerned about saying the wrong thing or taking responsibility for issues outside their role.',
            'Operators needed clear information that connected employee health with:',
            { type: 'list', items: [
              'Safety',
              'Attendance',
              'Management',
              'Retention',
              'Workplace culture',
              'Business performance',
            ]},
            'The sessions also needed to recognise the barriers men may face when discussing mental health.',
          ],
        },
        {
          heading: 'What Kalobrate did',
          content: [
            'Kalobrate delivered talks at two regional CPT compliance events.',
            'The sessions:',
            { type: 'list', items: [
              'Explained the business effects of poor workplace health',
              'Considered the pressures faced by bus and coach employees',
              'Explored why some men may be less likely to seek support',
              'Gave leaders practical ways to create safer conversations',
              'Clarified the role and boundaries of managers',
              'Showed how workplace data could help operators understand absence and related costs',
            ]},
            'The content used practical examples and clear language rather than clinical terminology.',
          ],
        },
        {
          heading: 'What happened',
          content: [
            'The talks reached around 100 bus and coach operators.',
            'Attendees received:',
            { type: 'list', items: [
              'A clearer understanding of workplace mental health',
              'Practical ways to support employees',
              'Guidance on safer conversations',
              'Ideas for helping managers respond',
              'A clearer link between employee health, safety and business performance',
            ]},
          ],
        },
      ]}
      quotes={[
        { text: "Before working with Fred Wellbeing, many CPT members were concerned about fatigue and mental health challenges highlighted by the Traffic Commissioners. Ollie delivered an engaging, data-led presentation using real-life language that resonated with operators. Feedback was very positive, with many realising the importance and business benefits of supporting mental health. We'd recommend Fred Wellbeing for their understanding of male mental health and their practical, relatable approach.", name: 'Andrew McGuinness', role: 'Regional Manager, Confederation of Passenger Transport' },
      ]}
      mainLesson={[
        'Leaders are more likely to act when difficult subjects are explained in language that fits their sector.',
        'The talks helped remove some of the confusion around workplace mental health and gave operators practical actions they could consider within their own businesses.',
      ]}
      cta={{
        heading: 'Planning an event for leaders in an operational sector?',
        copy: 'Kalobrate delivers practical talks and facilitated sessions that connect workplace health, culture and business performance.',
        button: 'Talk to Ollie',
      }}
    />
  </PageLayout>
);

export default CPTPage;
